import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import GlobalSearch from "@/components/feature/GlobalSearch";

const navItems = [
  { label: "首页", path: "/" },
  { label: "新闻", path: "/news" },
  { label: "剧情", path: "/plot" },
  { label: "演员", path: "/cast" },
  { label: "推荐", path: "/recommend" },
  { label: "关于", path: "/about" },
  { label: "联系", path: "/contact" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled && !mobileOpen;

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 24);
    }
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const linkBase = "relative whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors";
  const linkColor = transparent
    ? "text-background-50/90 hover:text-background-50"
    : "text-foreground-700 hover:text-primary-700";
  const activeColor = transparent ? "text-background-50" : "text-primary-700";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        transparent ? "bg-transparent" : "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              transparent ? "bg-background-50/20" : "bg-primary-500"
            }`}
          >
            <i
              className={`ri-leaf-line w-5 h-5 flex items-center justify-center text-lg ${
                transparent ? "text-background-50" : "text-background-50"
              }`}
            ></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-heading text-base font-bold ${transparent ? "text-background-50" : "text-foreground-950"}`}>
              蜜桃成熟时3D
            </span>
            <span className={`text-[10px] tracking-widest ${transparent ? "text-background-50/70" : "text-foreground-500"}`}>
              PEACH · 3D
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `${linkBase} ${isActive ? activeColor : linkColor}`}
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span
                      className={`absolute inset-x-3 -bottom-0.5 h-0.5 rounded-full ${
                        transparent ? "bg-background-50" : "bg-primary-500"
                      }`}
                    ></span>
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <GlobalSearch />
          <Link
            to="/detail/n1"
            className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            查看预告
          </Link>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="打开菜单"
            className={`flex h-10 w-10 items-center justify-center rounded-md ${
              transparent ? "text-background-50" : "text-foreground-800"
            }`}
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <div className="mb-3">
            <GlobalSearch onNavigate={() => setMobileOpen(false)} />
          </div>
          <nav className="grid grid-cols-2 gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}